module.exports = __webpack_public_path__ + "static/media/oracle_logo.99b5f7c4.png";